import {BaseTerms} from "../../infrastructure/models/base-terms";

export class PromotedSponsorshipModuleTerms extends BaseTerms {}
